import React from 'react';
import './PanelSkeleton.scss';

export default function PanelSkeleton({ rows = 6, columns = 5, label = 'Loading', header = false, variant = 'table', tableColumns = null }) {
  if (variant === 'order') return <div className="panel-skeleton panel-skeleton--order" role="status" aria-label={label} aria-busy="true">
    <div className="skeleton-order-layout" aria-hidden="true">
      <i className="skeleton-balance" />
      {Array.from({ length: rows === 6 ? 2 : rows }, (_, index) => <div className="skeleton-field" key={index}><i /><div className="skeleton-input"><i /><i /></div></div>)}
      {rows === 1 && <div className="skeleton-slider"><div className="skeleton-slider-track" /><div className="skeleton-slider-labels">{[0, 1, 2, 3, 4].map(value => <i key={value} />)}</div></div>}
      <div className="skeleton-checks"><i /><i /></div>
      <div className="skeleton-actions"><i /><i /></div>
      <div className="skeleton-totals"><i /><i /></div>
    </div>
  </div>;
  if (variant === 'symbols') return <div className="panel-skeleton panel-skeleton--symbols" role="status" aria-label={label} aria-busy="true">
    <div aria-hidden="true"><div className="skeleton-category"><i /></div>
      {Array.from({ length: rows }, (_, row) => <div className="skeleton-symbol" key={row}>
        <i className="skeleton-bookmark" /><div className="skeleton-symbol-name"><i /><i className="skeleton-description" /></div><i /><i />
      </div>)}
      <div className="skeleton-category"><i /></div><div className="skeleton-category"><i /></div>
    </div>
  </div>;
  const visibleColumns = tableColumns?.filter(column => !column.omit);
  const count = visibleColumns?.length || columns;
  return <div className="panel-skeleton" role="status" aria-label={label} aria-busy="true">
    <div aria-hidden="true">
      {header && <div className="panel-skeleton__heading"><i /><i /></div>}
      {Array.from({ length: rows }, (_, row) => <div key={row} className="panel-skeleton__row"
        style={{ gridTemplateColumns: visibleColumns ? visibleColumns.map(column => column.width || (column.grow === 0 ? (column.minWidth || '100px') : `minmax(${column.minWidth || '100px'}, ${column.grow || 1}fr)`)).join(' ') : `repeat(${count}, minmax(0, 1fr))` }}>
        {Array.from({ length: count }, (_, column) => <i key={column}
          style={{ width: `${[64, 45, 72, 53][(row + column) % 4]}%` }} />)}
      </div>)}
    </div>
  </div>;
}
